// Brand logos come from logo.dev, keyed by the company's web domain.
const LOGO_DEV_TOKEN = 'pk_GI6RnEUWRPmBnxZpagQkUQ';

export function brandLogoUrl(domain: string): string {
  return `https://img.logo.dev/${domain}?token=${LOGO_DEV_TOKEN}`;
}

/**
 * Company.domains is free text (one or more domains, possibly with protocol/www/path).
 * Returns the first bare domain, e.g. "https://www.typhur.com/shop, typhur.co" -> "typhur.com".
 */
export function primaryDomain(domains: string | null | undefined): string {
  const first = (domains ?? '').split(/[\s,;]+/).find(d => d.length > 0) ?? '';
  return first
    .replace(/^[a-z]+:\/\//i, '')
    .replace(/^www\./i, '')
    .split(/[/?#]/)[0]
    .toLowerCase();
}
